import React, { useRef, useState, useEffect } from 'react';
import './App.css';
import BookReader, { BookReaderRef } from './components/BookReader';
import UserIdInput from './components/UserIdInput';
import { hasUserId } from './utils/userId';

function App() {
  const bookReaderRef = useRef<BookReaderRef>(null);
  const [isUserIdSet, setIsUserIdSet] = useState<boolean>(false);
  const [isChecking, setIsChecking] = useState<boolean>(true);

  useEffect(() => {
    // 컴포넌트 마운트 시 userId 확인
    setIsUserIdSet(hasUserId());
    setIsChecking(false);
  }, []);

  const handleUserIdSet = () => {
    setIsUserIdSet(true);
  };

  const handleGoHome = () => {
    if (bookReaderRef.current) {
      bookReaderRef.current.handleBackToBooks();
    }
  };

  // userId 확인 중이면 로딩 표시
  if (isChecking) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}>
        <p>로딩 중...</p>
      </div>
    );
  }

  // userId가 없으면 입력 화면 표시
  if (!isUserIdSet) {
    return <UserIdInput onUserIdSet={handleUserIdSet} />;
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1 
          onClick={handleGoHome}
          style={{ cursor: 'pointer', margin: 0 }}
        >
          Let's read the Book aloud
        </h1>
      </header>
      <main>
        <BookReader ref={bookReaderRef} />
      </main>
    </div>
  );
}

export default App;
